var _style, _path, _path2, _g, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCypressLogomarkDarkColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x30_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 963 961.4",
    style: {
      enableBackground: "new 0 0 963 961.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B1E2E;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#69D3A7;}\n\t.st3{fill:url(#SVGID_00000012459936544953216520000005485075107941418661_);}\n\t.st4{fill:url(#SVGID_00000088124283916206697970000005493494615170137236_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.4,382.8c38.4,0,69.6,20.5,85.6,56.1l1.2,2.8l64.4-21.9l-1.3-3.3c-24.9-60.8-82.4-98.5-149.9-98.5 c-47.5,0-86.1,15.2-118,46.5c-31.7,31.1-47.7,70.2-47.7,116.2c0,45.7,16.1,84.6,47.7,115.6c31.9,31.3,70.5,46.5,118,46.5 c67.5,0,124.9-37.8,149.9-98.5l1.3-3.3l-64.5-21.9L426,522c-14.4,35.1-46.4,56-85.6,56c-26.7,0-49.3-9.3-67.1-27.7 c-18.1-18.6-27.2-42.1-27.2-69.6c0-27.7,8.9-50.7,27.2-70.2C291.2,392.1,313.7,382.8,340.4,382.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 992.9913,
    y1: 483.702,
    x2: 568.8699,
    y2: 758.3042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0814251,
    style: {
      stopColor: "#69D3A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69D3A7",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M620,934.4l-19.2-63.3C774,818.5,890.4,661.6,890.4,480.7c0-49.9-8.9-98.7-26.5-144.9l61.8-23.5 c20.5,53.8,30.9,110.4,30.9,168.5C956.5,690.9,821.3,873.2,620,934.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M872.5,361.1c-52.9-172.6-210-288.5-391-288.5c-24.6,0-49.2,2.2-73.2,6.5L396.6,14c27.8-5,56.4-7.6,84.9-7.6 c210.2,0,392.7,134.7,454.2,335.2L872.5,361.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148651166423619572140000005281795770302588552_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.3837,
    y1: 12.3964,
    x2: 56.9357,
    y2: 577.5029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69D3A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    style: {
      stopColor: "#2AB586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1CAE7F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148651166423619572140000005281795770302588552_)"
    },
    d: "M36.9,647.9 C16.7,594.5,6.5,538.2,6.5,480.7c0-245,183.9-447.9,427.8-471.9l6.5,65.8C230.9,95.3,72.6,269.9,72.6,480.7 c0,49.5,8.8,98,26.1,143.9L36.9,647.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "743.7,324 652,556.4 559.6,324 484,324 613.6,641.2 519.2,870.2 585.3,883.4 815.1,324  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098925399032608532410000009288675756932014269_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.8284,
    y1: 697.8476,
    x2: 704.4937,
    y2: 917.1161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0773521,
    style: {
      stopColor: "#1CAE7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1638,
    style: {
      stopColor: "#1CA379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3161,
    style: {
      stopColor: "#1C8568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    style: {
      stopColor: "#1B554D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    style: {
      stopColor: "#1B1E2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098925399032608532410000009288675756932014269_)"
    },
    d: "M531.1,841.4l-13.9,33.7 c-3.2,7.7-10.5,13-18.7,13.3c-5.7,0.2-11.3,0.4-17.1,0.4c-181.5,0-343.1-121.5-393-295.5l-63.6,18.2 c58,202.1,245.7,343.3,456.5,343.4c0,0,0,0,0,0c0,0,0.1,0,0.1,0v0c6.6,0,13.2-0.1,19.8-0.4c33.9-1.4,64.2-22.7,77.2-54.2l18.8-45.7 L531.1,841.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypressLogomarkDarkColor);
export default __webpack_public_path__ + "static/media/Cypress_Logomark_Dark-Color.7d75ebd5c48620c6ac12b68bc9b9dbd6.svg";
export { ForwardRef as ReactComponent };